// Auto-generated during build - do not edit manually
export const PORTAL_VERSION = '0.19.0';

export const VERSION_CONFIG = {
  version: PORTAL_VERSION,
  buildDate: '2025-11-29',
  showVersionInfo: true,
};
